import React from "react";
import SectionCard from "../SectionCard";
import { ExportCircle, ImportCircle } from "iconsax-react";
import Button from "../Button";

const GroupMemberListing = ({
  members,
  handleCheckIn,
  handleCheckOut,
  handleMemberClick,
}) => {
  return (
    <SectionCard title="Group Members" collapsible>
      <div className="flex flex-col w-full">
        {members && members.length > 0 ? (
          <div className="flex flex-col w-full h-full">
            {handleCheckIn && handleCheckOut && (
              <div className="flex w-full gap-[16px] p-[24px]">
                <Button
                  className="w-full"
                  onClick={() => handleCheckIn({ type: "all" })}
                >
                  <ImportCircle size="16" variant="Outline" />
                  Check In All
                </Button>
                <Button
                  className="w-full"
                  variant="error"
                  onClick={() => handleCheckOut({ type: "all" })}
                >
                  <ExportCircle size="16" variant="Outline" />
                  Check Out All
                </Button>
              </div>
            )}
            {members.map((member, index) => (
              <div
                className={`flex w-full gap-[12px] items-center justify-between p-[24px] ${
                  handleMemberClick && "hover:bg-[#F7F8FA] cursor-pointer"
                }`}
                key={index}
                onClick={() => {
                  if (handleMemberClick) handleMemberClick(member.uuid);
                }}
              >
                <p className="flex min-h-[42px] border border-[#EFF0F2] items-center justify-center rounded-lg text-[20px] text-nowrap px-2">
                  {member.table_name ?? "-"}
                </p>

                <div className="flex flex-col w-full text-[14px] font-normal">
                  <p>
                    {member.salutation && `${member.salutation}. `}
                    {member.name}
                  </p>
                  <div>
                    <p className="text-[12px] text-[#636C7E]">
                      {[member.email, member.contact, member.group_name]
                        .filter(Boolean)
                        .join(" / ")}
                    </p>
                  </div>
                  {member.tags && member.tags.length > 0 && (
                    <div className="flex flex-wrap gap-[4px] mt-[4px]">
                      {member.tags.map((tag, idx) => (
                        <span
                          key={idx}
                          className="bg-[#EFEDFE] border text-[#5C4BF5] text-[11px] font-medium px-[8px] py-[4px] rounded-md"
                        >
                          {tag.name}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                {handleCheckIn && handleCheckOut && (
                  <div className="flex justify-end w-fit">
                    {member.status ? (
                      <Button
                        variant="error"
                        className="h-full"
                        onClick={() => handleCheckOut({ id: member.id })}
                      >
                        <ExportCircle size="16" variant="Outline" />
                      </Button>
                    ) : (
                      <Button
                        className="h-full"
                        onClick={() => handleCheckIn({ id: member.id })}
                      >
                        <ImportCircle size="16" variant="Outline" />
                      </Button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="flex w-full min-h-[100px] items-center justify-center text-gray-400">
            <h1>No group members</h1>
          </div>
        )}
      </div>
    </SectionCard>
  );
};

export default GroupMemberListing;
